import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d976f73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-tab-content" }

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import SummaryCards from './SummaryCards.vue'
import PositionTable from './PositionTable.vue'
import type { TableColumn } from './hooks/useAccountDetail'

interface SubTab {
  label: string
  name: string
}

interface CardItem {
  label: string
  value: string
  showTip?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountTabContent',
  props: {
    subTabs: null,
    cards: null,
    columns: null,
    tableData: null,
    loading: { type: Boolean },
    defaultSubTab: null
  },
  emits: ['sub-tab-change'],
  setup(__props: any, { emit }) {

const props = __props as {
  subTabs: SubTab[]
  cards: CardItem[]
  columns: TableColumn[]
  tableData: any[]
  loading?: boolean
  defaultSubTab?: string
};



const router = useRouter()



const activeSubTab = ref(props.defaultSubTab || props.subTabs[0]?.name || '')

watch(
  () => props.defaultSubTab,
  (val) => {
    if (val) activeSubTab.value = val
  }
)

const onSubTabChange = () => {
  emit('sub-tab-change', activeSubTab.value)
}

const handleBuy = (row: any) => {
  const arr = []
  const {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    currentPriceDisplay: entrustPrice
  } = row
  arr[0] = {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    entrustPrice
  }
  router.push({
    name: 'BulkTrading',
    params: {
      bidAskList: JSON.stringify(arr)
    }
  })
}

const handleSell = (row: any) => {
  const arr = []
  const {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    currentPriceDisplay: entrustPrice
  } = row
  arr[0] = {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    entrustPrice
  }
  router.push({
    name: 'BulkTrading',
    params: {
      bidAskList: JSON.stringify(arr)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.subTabs.length > 0)
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: activeSubTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSubTab).value = $event)),
          class: "sub-tabs",
          onTabChange: onSubTabChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subTabs, (tab) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: tab.name,
                label: tab.label,
                name: tab.name
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(SummaryCards, {
      cards: __props.cards,
      loading: __props.loading,
      class: _normalizeClass({ 'no-sub-tabs': __props.subTabs.length === 0 })
    }, null, 8, ["cards", "loading", "class"]),
    _createVNode(PositionTable, {
      columns: __props.columns,
      "table-data": __props.tableData,
      loading: __props.loading,
      onBuy: handleBuy,
      onSell: handleSell
    }, null, 8, ["columns", "table-data", "loading"])
  ]))
}
}

})